import { render, staticRenderFns } from "./ActualizarEmisionNew.vue?vue&type=template&id=89b49ba0"
import script from "./ActualizarEmisionNew.vue?vue&type=script&lang=js"
export * from "./ActualizarEmisionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports